import { TELEGRAM_MINI_APP_URL } from '../config';

export function Footer() {
  return (
    <footer className="border-t border-tea-100 bg-white py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid sm:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="font-bold text-tea-900 mb-3">Shennong Tea</h3>
            <p className="text-sm text-tea-600 leading-relaxed">
              Оптовые поставки премиального чая напрямую из Китая. Более 100 сортов с доставкой по всей России.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-tea-900 mb-3">Контакты</h3>
            <div className="space-y-2 text-sm text-tea-600">
              <a
                href={TELEGRAM_MINI_APP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-tea-800 transition-colors"
              >
                <span>🛒</span>
                <span>Открыть каталог в Telegram</span>
              </a>
            </div>
          </div>
          <div>
            <h3 className="font-semibold text-tea-900 mb-3">Информация</h3>
            <div className="space-y-2 text-sm text-tea-600">
              <a href="#catalog" className="block hover:text-tea-800 transition-colors">Каталог товаров</a>
              <a href="#how" className="block hover:text-tea-800 transition-colors">Как это работает</a>
              <a href="#faq" className="block hover:text-tea-800 transition-colors">FAQ</a>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-tea-100 text-center text-sm text-tea-500">
          <p>© 2025 Shennong Tea. Оптовые поставки чая.</p>
        </div>
      </div>
    </footer>
  );
}
